import { Layout } from '@lemonade-hq/uniclient-theme';
import type { PropsWithChildren } from 'react';

export const WizardHeaderSide: React.FC<PropsWithChildren> = ({ children }) => (
  <Layout display={{ sm: 'none', lg: 'flex' }} height="fit-content" zIndex={1}>
    {children}
  </Layout>
);
